import { useQuery } from "@tanstack/react-query";
import { checkSessionStatus } from "base/utils/auth";
import queryKeys from "base/constant/queryKeys";

export default function useAuth() {
  // Auth state lives server-side now (HANBIRO_GW is httpOnly), so this is a network check.
  const { data, isLoading, isError } = useQuery({
    queryKey: [queryKeys.sessionStatus],
    queryFn: checkSessionStatus,
    // Any failure means "not logged in", so retrying only delays the redirect.
    retry: false,
  });

  const isLoggedIn = !isError && data?.success === true;

  return { isLoggedIn, isLoading };
}
